const RESOURCE_PREFIX = 'emap_res_';
// 仅用于静态 icon 资源，不再缓存任何瓦片
const TILE_PREFIX = 'emap_tile_disabled_';
const TILE_INDEX_KEY = 'emap_tile_index_disabled';
const MAX_TILE_ENTRIES = 0;

export const MAP_RESOURCE_CACHE_KEYS = {
  enabledCampusMarker: 'enabled_campus_marker',
  disabledCampusMarker: 'disabled_campus_marker',
  premarkCampusMarker: 'premark_campus_marker',
  studentMarker: 'student_marker'
};

function getStorage() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
  } catch (e) {
    // ignore
  }
  return null;
}

function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function readTileIndex() {
  // 瓦片缓存整体关闭
  return {};
}

function writeTileIndex(indexMap) {
  // 瓦片缓存整体关闭，什么都不做
  return;
}

function compactTileCache(indexMap, targetSize = MAX_TILE_ENTRIES) {
  // 瓦片缓存整体关闭
  return indexMap || {};
}

async function fetchAsDataURL(url) {
  const resp = await fetch(url, { cache: 'no-store' });
  if (!resp.ok) throw new Error('fetch failed');
  const blob = await resp.blob();
  return blobToDataURL(blob);
}

function setCachedResource(cacheKey, dataUrl) {
  const storage = getStorage();
  if (!storage || !dataUrl) return;
  try {
    storage.setItem(`${RESOURCE_PREFIX}${cacheKey}`, dataUrl);
  } catch (e) {
    // ignore quota
  }
}

export function getCachedMapResource(cacheKey, fallbackUrl) {
  const storage = getStorage();
  if (!storage) return fallbackUrl;
  try {
    return storage.getItem(`${RESOURCE_PREFIX}${cacheKey}`) || fallbackUrl;
  } catch (e) {
    return fallbackUrl;
  }
}

export async function preloadMapStaticResources(resourceEntries) {
  const list = Array.isArray(resourceEntries) ? resourceEntries : [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (!item || !item.cacheKey || !item.url) continue;
    try {
      const dataUrl = await fetchAsDataURL(item.url);
      setCachedResource(item.cacheKey, dataUrl);
    } catch (e) {
      // ignore single resource failure
    }
  }
}

export async function preloadInitialTileSet() {
  // 瓦片预热逻辑整体关闭，避免任何 OSM / 服务器瓦片缓存
  return;
}
